function falcorPortfolioId(portfolioId) {
  return portfolioId.replace('.', '-');
}

function apiPortfolioId(portfolioId) {
  return portfolioId.replace('-', '.');
}

module.exports = {
  falcorPortfolioId,
  apiPortfolioId,
};
